module.exports = {"420204004":"团城山街道","420204005":"新下陆街道","420204006":"老下陆街道","420204007":"东方山街道","420204401":"长乐山工业园管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420204.json
// module id = 1836
// module chunks = 0